$(document).ready(function () {

    let controller = new ScrollMagic.Controller();
    let header_bar = document.getElementById('header-bar');
    let footer_background = document.getElementById('footer_background');
    if (header_bar !== null) {
        new ScrollMagic.Scene({
            offset: 100
        })
            .setClassToggle("#header-bar", "nav-pre") // add class toggle
            .addTo(controller);
    }
    if (footer_background !== null) {
        new ScrollMagic.Scene({
            triggerElement: "#footer_background",
            offset: -50
        })
            .setClassToggle("#footer_background", "translate") // add class toggle
            .addTo(controller);
    }



})
